var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74987 8.99982H4.16653M4.09599 9.24274L2.15022 15.055C1.99736 15.5116 1.92093 15.7399 1.97578 15.8805C2.02341 16.0026 2.12571 16.0952 2.25195 16.1304C2.39731 16.171 2.61687 16.0722 3.05598 15.8746L16.9822 9.60778C17.4108 9.4149 17.6251 9.31847 17.6913 9.1845C17.7489 9.06811 17.7489 8.93155 17.6913 8.81516C17.6251 8.68119 17.4108 8.58475 16.9822 8.39188L3.05112 2.12293C2.61334 1.92593 2.39444 1.82742 2.24922 1.86783C2.12311 1.90292 2.02082 1.99524 1.97302 2.11711C1.91798 2.25744 1.9936 2.48526 2.14482 2.94088L4.09653 8.8211C4.1225 8.89935 4.13549 8.93848 4.14062 8.9785C4.14517 9.01401 4.14512 9.04996 4.14048 9.08546C4.13525 9.12546 4.12216 9.16455 4.09599 9.24274Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.0e63785d0f25d63c856d81859e7129a6.svg";
export { ForwardRef as ReactComponent };